import { useNavigate } from "react-router-dom";


export default function Homepage() {
  const router = useNavigate();
  return (
    <>
      <div className="bg-gray-100 min-h-screen">
        <nav className="bg-gray-100 shadow-sm py-4 fixed top-0 w-full">
          <div className="container mx-auto">
            <ul className="flex justify-center space-x-6">
              <li>
                <a
                  href="#features"
                  className="text-gray-800 hover:text-red-600 font-medium text-xl transition duration-300 ease-in-out transform hover:-translate-y-1"
                >
                  Features
                </a>
              </li>
              <li>
                <a
                  href="#download"
                  className="text-gray-800 hover:text-red-600 font-medium text-xl transition duration-300 ease-in-out transform hover:-translate-y-1"
                >
                  Download App
                </a>
              </li>
              <li>
                <a
                     href="#contact"
                  className="text-gray-800 hover:text-red-600 font-medium text-xl transition duration-300 ease-in-out transform hover:-translate-y-1"
                >
                  Contact
                </a>
              </li>
              <li>
                <a
                 onClick={()=>router('/privacy')}
              
                  className="text-gray-800 hover:text-red-600 font-medium text-xl transition duration-300 ease-in-out transform hover:-translate-y-1"
                >
                  Privacy
                </a>
              </li>
            </ul>
          </div>
        </nav>
        <header className="bg-gradient-to-r from-purple-800 to-black text-white text-center py-12 mt-20">
          <h1 className="text-4xl font-extrabold">Welcome to Dailo</h1>
          <p className="mt-4 text-lg text-gray-300">Your Journey, Your Way</p>
        </header>

        <section id="hero" className="bg-gradient-to-r from-purple-800 to-black text-white py-24 text-center">
          <h2 className="text-3xl font-semibold">Discover Seamless Travel with Dailo</h2>
          <p className="mt-4 text-lg text-gray-300">Efficient, Eco-friendly, and Affordable</p>
          <a href="#download" className="mt-8 inline-block px-6 py-3 bg-blue-500 text-white rounded-full hover:bg-blue-600 transition duration-300 ease-in-out transform hover:scale-105">
            Get Started
          </a>
        </section>
        <section id="features" className="py-16 bg-gray-100">
          <h2 className="text-4xl font-semibold text-center mb-12 text-gray-800">Why Choose Dailo?</h2>
          <ul className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-8">
            <li className="bg-white p-8 rounded-lg shadow-lg hover:shadow-xl transition duration-300 ease-in-out transform hover:-translate-y-1">
              <h3 className="text-2xl font-semibold text-gray-800">Convenience</h3>
              <p className="mt-4 text-gray-600">Say goodbye to waiting for public transport or struggling to find parking.</p>
            </li>
            <li className="bg-white p-8 rounded-lg shadow-lg hover:shadow-xl transition duration-300 ease-in-out transform hover:-translate-y-1">
              <h3 className="text-2xl font-semibold text-gray-800">Affordability</h3>
              <p className="mt-4 text-gray-600">Experience luxury without the high costs. Share rides and split the fare.</p>
            </li>
            <li className="bg-white p-8 rounded-lg shadow-lg hover:shadow-xl transition duration-300 ease-in-out transform hover:-translate-y-1">
              <h3 className="text-2xl font-semibold text-gray-800">Safety First</h3>
              <p className="mt-4 text-gray-600">Background-checked drivers, real-time tracking, and trip-sharing for peace of mind.</p>
            </li>
            <li className="bg-white p-8 rounded-lg shadow-lg hover:shadow-xl transition duration-300 ease-in-out transform hover:-translate-y-1">
              <h3 className="text-2xl font-semibold text-gray-800">Eco-Friendly</h3>
              <p className="mt-4 text-gray-600">Reduce carbon emissions by sharing rides and contributing to a greener planet.</p>
            </li>
          </ul>
        </section>
        <section id="download" className="bg-gradient-to-r from-blue-700 via-blue-600 to-blue-700 text-white py-20 text-center">
          <h2 className="text-4xl font-semibold text-gray-100 mb-6">Get Started Today</h2>
          <p className="mt-4 text-lg text-gray-200">Download the RideConnect app and start your journey!</p>
          <a href="https://drive.google.com/file/d/1VZsPjVQLmNPGL0NBC0Otx1GdhcZmjZxJ/view?pli=1" className="mt-8 inline-block px-12 py-3 bg-white text-blue-700 rounded-full hover:bg-blue-100 hover:text-blue-800 transition duration-300 ease-in-out transform hover:scale-105">
            Download Now
          </a>
        </section>
        <section id="contact" className="py-16 bg-gray-100 text-center">
  <h2 className="text-4xl font-semibold text-gray-800 mb-6">Contact Us</h2>
  <p className="mt-4 text-lg text-gray-600">Have questions? Reach out to our 24/7 support team.</p>
  <div className="mt-8 text-gray-600">
    <p className="mt-2">
     
      Email: <a href="mailto:info@dailo.cloud" className="text-blue-600 hover:underline">info@dailo.cloud</a>
    </p>
    <p className="mt-2"> 
      Phone: <a href="tel:(977) 9848472132" className="text-blue-600 hover:underline">(977) 9848472132</a>
    </p>
    <p className="mt-2"> 
      Location: <a className="text-blue-600 hover:underline">Blue Grasss Online Service, Dhangadhi</a>
    </p>
  </div>
</section>
<footer className="bg-gray-900 py-8 text-center">
  <p className="text-gray-300 text-lg">&copy; 2023 Dailo. All rights reserved.</p>
  <div className="flex justify-center space-x-4 mt-6">
    <a href="#" className="text-gray-300 hover:text-blue-500">
      <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        {/* Add your Facebook icon SVG here */}
      </svg>
    </a>
    <a href="#" className="text-gray-300 hover:text-blue-400">
      <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        {/* Add your Twitter icon SVG here */}
      </svg>
    </a>
    <a href="#" className="text-gray-300 hover:text-pink-500">
      <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        {/* Add your Instagram icon SVG here */}
      </svg>
    </a>
  </div>
</footer>
      </div>
    </>
  );
}